import { FinanceIcon } from "@trafficsharkdsp/ui";
import dayjs from "dayjs";

import cls from "../ui/NotificationDropdown.module.css";

import { AllNotifications } from "@/entities/notification/model/type/notification-type";

export const renderNotificationLabel = (notification: AllNotifications) => {
    const { description, created_at } = notification;
    const createdDate = created_at
        ? dayjs(created_at).format("MMMM D, h:mm a")
        : dayjs().format("MMMM D, h:mm a");

    return (
        <div className={cls.item}>
            <FinanceIcon className={cls.icon} />
            <div className={cls["item-text"]}>
                <span className={cls.text}>{description}</span>
                <span className={cls.time}>{createdDate}</span>
            </div>
        </div>
    );
};
